<template>
  <div class="wrapper">

    <p class="mainContainer__mainTitle mainContainer__mainTitle--mod01">{{ $t('mainContainer.mainTitle') }}</p>

    <div class="mainContainer">

      <div class="mainContainer__box mainContainer__box--mod01">

        <div class="navigation">
          <router-link class="navigation__link navigation__link--active navigation__link--done" to="/"><span><i
                class="ri-check-fill"></i></span> {{ $t('mainContainer.stepOne') }}</router-link>
          <router-link class="navigation__link navigation__link--active" to="/"><span><i
                class="ri-map-pin-line"></i></span> {{ $t('mainContainer.stepTwo') }}</router-link>
          <router-link class="navigation__link" to="/"> {{ $t('mainContainer.stepThree') }}</router-link>
          <router-link class="navigation__link" to="/"> {{ $t('mainContainer.stepFour') }}</router-link>
          <router-link class="navigation__link" to="/">{{ $t('mainContainer.stepFive') }}</router-link>
        </div>

        <div class="formContainer">
          <p class="formContainer__infoText">
            {{ $t('vehicle.typeOfVehicle') }}<b>{{ currentVehicleLabel }}</b>{{ $t('vehicle.you_want') }}
          </p>
          <!-- Formulario de selección paso a paso -->
          <div v-if="!isOtherSelected" class="formContainer__carSelection">
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="atv" value="Atv" v-model="currentVehicleType">
            <label for="atv" class="carSelection__label">
              <img src="@/assets/img/vehicles/atv.svg" alt="Vehicle">
              <span>Atv</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="motorcycle" value="Motorcycle" v-model="currentVehicleType">
            <label for="motorcycle" class="carSelection__label">
              <img src="@/assets/img/vehicles/motorcycle.svg" alt="Vehicle">
              <span>Motorcycle</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="jetsky" value="Jetsky" v-model="currentVehicleType">
            <label for="jetsky" class="carSelection__label">
              <img src="@/assets/img/vehicles/jetsky.svg" alt="Vehicle">
              <span>Jetsky</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="sedan" value="Sedan" v-model="currentVehicleType">
            <label for="sedan" class="carSelection__label">
              <img src="@/assets/img/vehicles/sedan.svg" alt="Vehicle">
              <span>Sedan</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="smallsuv" value="Small SUV" v-model="currentVehicleType">
            <label for="smallsuv" class="carSelection__label">
              <img src="@/assets/img/vehicles/smallsuv.svg" alt="Vehicle">
              <span>Small SUV</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="suv" value="SUV" v-model="currentVehicleType">
            <label for="suv" class="carSelection__label">
              <img src="@/assets/img/vehicles/suv.svg" alt="Vehicle">
              <span>SUV</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="minivan" value="Minivan" v-model="currentVehicleType">
            <label for="minivan" class="carSelection__label">
              <img src="@/assets/img/vehicles/minivan.svg" alt="Vehicle">
              <span>Minivan</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="pickup1500" value="Pickup 1500" v-model="currentVehicleType">
            <label for="pickup1500" class="carSelection__label">
              <img src="@/assets/img/vehicles/pickup1500.svg" alt="Vehicle">
              <span>Pickup 1500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="pickup2500" value="Pickup 2500" v-model="currentVehicleType">
            <label for="pickup2500" class="carSelection__label">
              <img src="@/assets/img/vehicles/pickup2500.svg" alt="Vehicle">
              <span>Pickup 2500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="pickup3500" value="Pickup 3500" v-model="currentVehicleType">
            <label for="pickup3500" class="carSelection__label">
              <img src="@/assets/img/vehicles/pickup3500.svg" alt="Vehicle">
              <span>Pickup 3500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="pickupfully" value="Pickup Dully" v-model="currentVehicleType">
            <label for="pickupfully" class="carSelection__label">
              <img src="@/assets/img/vehicles/pickupfully.svg" alt="Vehicle">
              <span>Pickup Dully 3500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="van1500" value="Van 1500" v-model="currentVehicleType">
            <label for="van1500" class="carSelection__label">
              <img src="@/assets/img/vehicles/cargovan2500.svg" alt="Vehicle">
              <span>Van 1500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="van2500" value="Van 2500" v-model="currentVehicleType">
            <label for="van2500" class="carSelection__label">
              <img src="@/assets/img/vehicles/cargovan1500.svg" alt="Vehicle">
              <span>Van 2500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="van3500" value="Van 3500" v-model="currentVehicleType">
            <label for="van3500" class="carSelection__label">
              <img src="@/assets/img/vehicles/cargovan3500.svg" alt="Vehicle">
              <span>Van 3500</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="luxurycar" value="Luxury Car" v-model="currentVehicleType">
            <label for="luxurycar" class="carSelection__label">
              <img src="@/assets/img/vehicles/luxurycar.svg" alt="Vehicle">
              <span>Luxury Car</span>
            </label>
            <input type="radio" class="carSelection__radioInput isHidden" :name="'carSelection' + currentVehicleStep" id="other" value="Other" v-model="currentVehicleType" @change="otherForm">
            <label for="other" class="carSelection__label carSelection__label--mod01">
              <img src="@/assets/img/vehicles/other.svg" alt="Vehicle">
              <span>Other</span>
            </label>
          </div>
          <!-- Show this when 'Other' is selected -->
          <div class="formContainer__carSelection-custom formContainer__inputBox" v-if="isOtherSelected">
            <select v-if="!brandNotFound" v-model="selectedBrand" @change="loadYears" style="width: 250px; margin-bottom: 20px">
              <option disabled value="">{{ $t('vehicle.select_brand') }}</option>
              <option v-for="brand in brands" :key="brand">{{ brand }}</option>
            </select>
            <select v-if="!brandNotFound && years.length > 0" v-model="selectedYear" @change="loadModels" style="width: 250px; margin-bottom: 20px">
              <option disabled value="">{{ $t('vehicle.select_year') }}</option>
              <option v-for="year in years" :key="year">{{ year }}</option>
            </select>
            <select v-if="!brandNotFound" v-model="selectedModel" style="width: 250px; margin-bottom: 20px">
              <option disabled value="">{{ $t('vehicle.select_model') }}</option>
              <option v-for="model in models" :key="model">{{ model }}</option>
            </select>
            <button v-if="!brandNotFound" @click="brandNotFound = true">{{ $t('vehicle.my_car_not_here') }}</button>
            <input v-if="brandNotFound" v-model="manualEntry" placeholder="Enter your car details manually">
          </div>
          <div class="formContainer__submitBox">
            <button class="formContainer__submit" v-on:click="backAction">{{ $t('back') }}</button>
            <button :disabled="!continueButtonCheck" class="formContainer__submit" id="continueStep" v-on:click="nextStep">{{ isLastStep ? $t('next') : $t('next') }}</button>
          </div>
        </div>

      </div>

      <div class="mainContainer__box mainContainer__box--mod01">

        <div class="mainContainer__informationalBox">

          <p class="infoSection__title infoSection__title--mod01">{{ $t('route_information') }}</p>

          <div class="informationalBox__infoSection informationalBox__infoSection--mod01">
            <div class="infoSection__container infoSection__container--33">
              <p class="infoSection__title">{{ $t('from') }}</p>
              <p class="infoSection__select" id="selectFrom"> {{ this.$store.state.routeData.fromAddress || '-' }} </p>
            </div>
            <div class="infoSection__container infoSection__container--33 infoSection__container--flex">
              <div class="infoSection__line"></div>
              <div class="infoSection__miles" id="distanceMiles"> {{ this.$store.state.routeData.distanceFromTo + ' MI' }} </div>
              <div class="infoSection__line"></div>
            </div>
            <div class="infoSection__container infoSection__container--33">
              <p class="infoSection__title infoSection__textAlignRight">{{ $t('to') }}</p>
              <p class="infoSection__select infoSection__textAlignRight" id="selectTo"> {{ this.$store.state.routeData.toAddress || '-' }} </p>
            </div>
          </div>

          <div class="informationalBox__infoSection">
            <div class="infoSection__container">
              <p class="infoSection__title">{{ $t('pickupdate')}}</p>
              <p class="infoSection__select"> {{ this.$store.state.routeData.pickupDate || '-' }} </p>
            </div>
            <div class="infoSection__container">
              <p class="infoSection__title">{{ $t('how_many_veh')}}</p>
              <p class="infoSection__select"> {{ this.$store.state.routeData.numberOfVehicles || '-' }} </p>
            </div>
          </div>

          <div class="informationalBox__infoSection">
            <div class="infoSection__container">
              <p class="infoSection__title" v-if="$store.state.routeData.numberOfVehicles == 1">{{ $t('transported_vehicule') }}</p>
              <p class="infoSection__title" v-if="$store.state.routeData.numberOfVehicles > 1">{{ $t('transported_vehicules') }}</p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles == 1"> {{ vehicleType || $t('selectVehicle.single') }} </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 1">1. {{ vehicleType || $t('selectVehicle.first') }} </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 1">2. {{ vehicleType_2 || $t('selectVehicle.second') }} </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 2">3. {{ vehicleType_3 || $t('selectVehicle.third') }} </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 3">4. {{ vehicleType_4 || $t('selectVehicle.fourth') }} </p>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "Vehicle",
  data() {
    return {
      vehicleType: '',
      vehicleType_2: '',
      vehicleType_3: '',
      vehicleType_4: '',
      continueButtonCheck: false,
      selectedBrand: '',
      selectedModel: '',
      selectedYear: '',
      manualEntry: '',
      brands: ["Acura", "Audi", "BMW", "Buick", "Cadillac", "Chevrolet", "Genesis", "GMC", "Honda", "Hyundai", "INFINITI", "Jaguar", "Kia", "Land Rover", "Lincoln", "Mazda", "MINI", "Mitsubishi", "Nissan", "Polestar", "Subaru", "Toyota", "Volvo", "Alfa Romeo", "Bentley", "Chrysler", "Dodge", "FIAT", "Ford", "Jeep", "Karma", "Lamborghini", "Lexus", "Lucid", "Maserati", "McLaren", "Mercedes-Benz", "Porsche", "Ram", "Rivian", "Rolls-Royce", "Tesla", "Volkswagen", "Aston Martin", "Lotus", "Ferrari", "smart", "Scion", "Suzuki", "Fisker", "Maybach", "Saab", "Mercury", "HUMMER", "Pontiac", "Bugatti", "Saturn", "Spyker", "Isuzu", "Panoz", "Oldsmobile", "Daewoo", "Plymouth", "AM General", "Eagle", "Geo", "VinFast"],
      models: [],
      years: Array.from({ length: 74 }, (_, i) => 2023 - i),
      brandNotFound: false,
      isOtherSelected: false,
      currentVehicleStep: 1, // Nuevo: paso actual de selección
    }
  },
  computed: {
    totalVehicles() {
      return this.$store.state.routeData.numberOfVehicles || 1;
    },
    currentVehicleType: {
      get() {
        switch (this.currentVehicleStep) {
          case 1: return this.vehicleType;
          case 2: return this.vehicleType_2;
          case 3: return this.vehicleType_3;
          case 4: return this.vehicleType_4;
          default: return '';
        }
      },
      set(val) {
        switch (this.currentVehicleStep) {
          case 1: this.vehicleType = val; break;
          case 2: this.vehicleType_2 = val; break;
          case 3: this.vehicleType_3 = val; break;
          case 4: this.vehicleType_4 = val; break;
        }
      }
    },
    currentVehicleLabel() {
      switch (this.currentVehicleStep) {
        case 1: return this.$t('vehicle.firstVehicle');
        case 2: return this.$t('vehicle.secondVehicle');
        case 3: return this.$t('vehicle.thirdVehicle');
        case 4: return this.$t('vehicle.fourthVehicle');
        default: return '';
      }
    },
    isLastStep() {
      return this.currentVehicleStep === this.totalVehicles;
    }
  },
  methods: {
    async loadModels() {
      this.models = [];
      try {
        const response = await axios.get(`https://vpic.nhtsa.dot.gov/api/vehicles/getmodelsformakeyear/make/${this.selectedBrand}/modelyear/${this.selectedYear}?format=json`);
        this.models = response.data.Results.map(item => item.Model_Name);
      } catch (error) {
        console.error("An error occurred while fetching data: ", error);
      }
    },
    loadYears() {
      this.selectedYear = '';
      this.models = [];
    },
    nextStep() {
      if (!this.isLastStep) {
        this.currentVehicleStep++;
        this.isOtherSelected = false;
        this.selectedBrand = '';
        this.selectedModel = '';
        this.selectedYear = '';
        this.manualEntry = '';
        this.brandNotFound = false;
        this.continueButtonCheck = false;
      } else {
        const vehicleData = {
          vehicleType: this.vehicleType,
          vehicleType_2: this.vehicleType_2,
          vehicleType_3: this.vehicleType_3,
          vehicleType_4: this.vehicleType_4
        };
        if (this.isOtherSelected) {
          if (this.manualEntry) {
            vehicleData.manualEntry = this.manualEntry;
          } else {
            vehicleData.selectedBrand = this.selectedBrand;
            vehicleData.selectedModel = this.selectedModel;
            vehicleData.selectedYear = this.selectedYear;
          }
        }
        this.$store.dispatch('SAVE_VEHICLE_STEP_ACTION', vehicleData);
        const nextRoute = this.isOtherSelected ? 'CustomAdditional' : 'Additional';
        this.$router.replace({ name: nextRoute });
      }
    },
    otherForm() {
      this.isOtherSelected = true;
    },
    backAction() {
      if (this.currentVehicleStep > 1) {
        this.currentVehicleStep--;
        this.isOtherSelected = false;
        this.selectedBrand = '';
        this.selectedModel = '';
        this.selectedYear = '';
        this.manualEntry = '';
        this.brandNotFound = false;
        this.continueButtonCheck = false;
      } else {
        this.$router.push({ name: "Home" });
      }
    },
    checkIfCanContinue() {
      if (!this.isOtherSelected) {
        if (this.currentVehicleType !== '') {
          this.continueButtonCheck = true;
        }
      } else {
        if (
          (this.selectedModel !== '' && this.selectedModel !== null) ||
          (this.manualEntry !== '' && this.manualEntry !== null)
        ) {
          this.continueButtonCheck = true;
        }
      }
    }
  },
  watch: {
    currentVehicleType(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        this.checkIfCanContinue();
      }
    },
    selectedModel(newValue, oldValue) {
      if (newValue) {
        this.checkIfCanContinue();
      }
    },
    manualEntry(newValue, oldValue) {
      if (newValue) {
        this.checkIfCanContinue();
      }
    },
    continueButtonCheck(newValue, oldValue) {
      if (newValue === true) {
        document.querySelector('#continueStep').removeAttribute("disabled");
      } else {
        document.querySelector('#continueStep').setAttribute("disabled", true);
      }
    }
  }
}
</script>